export default {
  ELEMENT_NODE: 1,
  TEXT_NODE: 3,
  COMMENT_NODE: 8
}


// WEBPACK FOOTER //
// ./src/common/components/process-editor/modules/dinnerSvg/share/NodeTypes.js